import { SelectHTMLAttributes } from 'react';

const filterSelectStyle: React.CSSProperties = {
  padding: '6px 12px',
  border: '1px solid #d1d5db',
  borderRadius: '4px',
  fontSize: '13px',
  fontWeight: 500,
  color: '#222',
  backgroundColor: '#fff',
  cursor: 'pointer',
  minWidth: '130px',
};

const filterLabelStyle: React.CSSProperties = {
  fontSize: '13px',
  fontWeight: 600,
  color: '#374151',
  whiteSpace: 'nowrap',
};

interface FilterSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
}

export function FilterSelect({ label, style, ...props }: FilterSelectProps) {
  const select = (
    <select style={{ ...filterSelectStyle, ...style }} {...props} />
  );

  if (!label) return select;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <label style={filterLabelStyle}>{label}</label>
      {select}
    </div>
  );
}

export { filterSelectStyle, filterLabelStyle };
